module.exports = __webpack_public_path__ + "static/media/grs.b95e5f98.svg";